import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Footer from 'components/footer';
import Header from 'components/header';
import Support from 'components/support';
import NewsModal from 'components/news-modal';
import SkipNavLink from 'components/skip-nav-link';

const USBL_MAIN_CONTENT_ID = 'usbl-main-content';

const themes = {
  noMinHeight: 'no-min-height',
  housingProject: 'housing-project'
};

const housingProjectThemes = {
  light: 'light',
  dark: 'dark'
};

const Layout = ({
  skipToMainContentLinkText,
  children,
  footer,
  fullWidthChildren,
  header,
  support,
  theme,
  newsModal,
  housingProjectTheme
}) => {
  const [isClient, setIsClient] = useState(false); // Flag for client-side rendering

  // Set the isClient flag to true after the component mounts
  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <React.Fragment>
      <SkipNavLink
        text={skipToMainContentLinkText}
        targetId={USBL_MAIN_CONTENT_ID}
      />
      {header && (
        <Header
          {...header}
          housingProjectMenu={
            header?.housingProjectMenu
              ? {
                  ...header.housingProjectMenu,
                  theme: housingProjectTheme
                }
              : null
          }
        />
      )}

      {(support || children) && (
        <main
          id={USBL_MAIN_CONTENT_ID}
          className={cn('layout', { [`layout--${theme}`]: theme })}
        >
          {fullWidthChildren}
          <div className="layout__content">{children}</div>
          {support && <Support {...support} />}
        </main>
      )}
      {newsModal && <NewsModal {...newsModal} />}
      {footer && <Footer {...footer} theme={theme} />}
    </React.Fragment>
  );
};

Layout.propTypes = {
  skipToMainContentLinkText: PropTypes.string,
  children: PropTypes.node,
  // NOTE: Footer is a tsx component typed with the generated FooterProps model and
  // has no propTypes to reference here
  footer: PropTypes.object,
  fullWidthChildren: PropTypes.node,
  header: PropTypes.exact(Header.propTypes),
  headerTheme: PropTypes.any,
  housingProjectTheme: PropTypes.oneOf(Object.values(housingProjectThemes)),
  support: PropTypes.exact(Support.propTypes),
  theme: PropTypes.oneOf(Object.values(themes)),
  newsModal: PropTypes.exact(NewsModal.propTypes)
};

Layout.propTypesMeta = {
  headerTheme: 'exclude',
  theme: 'exclude',
  housingProjectTheme: 'exclude'
};

Layout.themes = themes;

export default Layout;
